var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.container }, [
    _c(
      "div",
      {
        class: [
          _vm.$style.dropdown,
          ((_obj = {}),
          (_obj[_vm.$style.desktop] = _vm.desktop),
          (_obj[_vm.$style.loggedIn] = _vm.isLoggedIn),
          _obj)
        ]
      },
      [
        !_vm.isLoggedIn
          ? [
              _c(
                "button",
                {
                  staticClass: "hit-solid fluid",
                  class: _vm.$style.accentSolid,
                  on: { click: _vm.handleSignIn }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.translations.signIn) + "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              !_vm.hideSignUp
                ? _vm._t("new-customer", [
                    _vm.signUpUrl
                      ? _c("div", { class: _vm.$style.newCustomer }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.translations.newCustomerLabel) +
                              "\n          "
                          ),
                          _c(
                            "a",
                            {
                              class: _vm.$style.signupLink,
                              attrs: { href: _vm.signUpUrl }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.translations.signUpTodayLabel) +
                                  "\n          "
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.isLoggedIn
          ? _c("div", [
              !_vm.desktop && _vm._marketLoyalty.enabled
                ? _c("div", { class: _vm.$style.loyalty }, [
                    _c(
                      "a",
                      {
                        class: _vm.$style.loyaltyLink,
                        attrs: { href: _vm.rewardsPageUrl }
                      },
                      [
                        _c("span", { class: _vm.$style.loyaltyText }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.translations.enjoyLoyalty) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _vm.showPoints
                          ? _c(
                              "span",
                              { class: _vm.$style.loyaltyAvailableBalance },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.loyaltyAmount) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _vm.showDistPhotoNameId
                  ? _c("div", { class: _vm.$style.head }, [
                      _vm.desktop
                        ? _c(
                            "div",
                            { class: _vm.$style.headLeft },
                            [
                              _vm.user.photoURL
                                ? _c("div", {
                                    class: _vm.$style.profileImage,
                                    style:
                                      "background-image: url(" +
                                      _vm.user.photoURL +
                                      ";",
                                    attrs: { "data-testid": "profileImage" }
                                  })
                                : _c("NsIcon", {
                                    class: _vm.$style.profileIcon,
                                    attrs: {
                                      "icon-name": "icon-profile",
                                      size: "custom"
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _vm.desktop
                          ? _c("div", { class: _vm.$style.userName }, [
                              _vm._v(_vm._s(_vm.username))
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.translations.id) +
                            ": " +
                            _vm._s(_vm.user.id) +
                            "\n          "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showVolumes
                  ? _c(
                      "div",
                      { class: _vm.$style.userVolumes },
                      _vm._l(_vm.userVolumes, function(volume) {
                        return _c(
                          "div",
                          { key: volume.name, class: _vm.$style.volume },
                          [
                            _c("span", { class: _vm.$style.volumeName }, [
                              _vm._v(_vm._s(volume.name))
                            ]),
                            _vm._v(" "),
                            _c("span", { class: _vm.$style.volumeValue }, [
                              _vm._v(_vm._s(volume.value))
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isGuest
                  ? _c(
                      "ul",
                      { class: _vm.$style.nav },
                      [
                        _vm._l(_vm.filteredProfileMenu, function(menuItem) {
                          return _c("li", { key: menuItem.name }, [
                            _c(
                              "a",
                              {
                                class: _vm.$style.navLink,
                                attrs: { href: menuItem.href }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(menuItem.name) +
                                    "\n            "
                                )
                              ]
                            )
                          ])
                        }),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              class: _vm.$style.navLink,
                              attrs: { href: _vm.signOutUrl },
                              on: {
                                click: function(event) {
                                  return _vm.handleSignOut(event)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.translations.signOut) +
                                  "\n            "
                              )
                            ]
                          )
                        ])
                      ],
                      2
                    )
                  : _c("ul", { class: _vm.$style.nav }, [
                      _c("li", [
                        _c(
                          "a",
                          {
                            class: _vm.$style.navLink,
                            attrs: { href: _vm.signOutUrl },
                            on: {
                              click: function(event) {
                                return _vm.handleSignOut(event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.translations.signOut) +
                                "\n            "
                            )
                          ]
                        )
                      ])
                    ])
              ])
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }